import DashboardApiTableShow, {DashboardColumn} from './DashboardApiTableShow'
import {BuyboxOwnerChangeItem} from './dashboardTableTypes'
import {
  renderDashboardDateTwoLine,
  renderDashboardSellerNameWithId,
  renderDashboardSku,
} from './dashboardFormatters'

const columns: DashboardColumn<BuyboxOwnerChangeItem>[] = [
  {header: 'SKU', sortKey: 'sku', render: (item) => renderDashboardSku(item.sku)},
  {header: 'Channel', sortKey: 'channel', render: (item) => item.channel ?? '-'},
  {header: 'Type', sortKey: 'type', render: (item) => item.type ?? '-'},
  {header: 'Old Seller', sortKey: 'old_value', render: (item) => renderDashboardSellerNameWithId(item.old_seller_name, item.old_value)},
  {header: 'New Seller', sortKey: 'new_value', render: (item) => renderDashboardSellerNameWithId(item.new_seller_name, item.new_value)},
  {header: 'Changed At', sortKey: 'changed_at', width: 160, render: (item) => renderDashboardDateTwoLine(item.changed_at)},
  // {header: 'Broken Link', render: (item) => renderDashboardLink(item.broken_link)},
]

function BuyboxOwnerChangesShow() {
  return (
    <DashboardApiTableShow<BuyboxOwnerChangeItem>
      endpoint='BuyboxOwnerChanges'
      title='Buybox Owner Changes'
      columns={columns}
    />
  )
}

export default BuyboxOwnerChangesShow
